/**
 * Recherche de modèle de véhicule — partagée SaaS ↔ widget.
 *
 * Le texte tapé est comparé au nom du modèle puis à ses alias (`aliases`, ex. Q5 →
 * SQ5, Serie 3 → 320d), sans tenir compte de la casse, des accents, des apostrophes,
 * des tirets, des points ni des espaces : « megane » trouve « Mégane », « ceed »
 * trouve « Cee'd », « c220 » trouve l'alias « C 220 ».
 */

import type { VehicleModel } from '../types'

/** Forme comparable d'un texte : minuscules, sans accents ni séparateurs. */
export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[\s'’.\-_/]/g, '')
}

export interface VehicleModelMatch {
  matched: boolean
  /** Alias qui a donné le résultat (à afficher au client), null si c'est le nom du modèle. */
  alias: string | null
}

export function matchVehicleModel(model: Pick<VehicleModel, 'model' | 'aliases'>, query: string): VehicleModelMatch {
  const needle = normalizeSearchText(query)
  if (!needle || normalizeSearchText(model.model).includes(needle)) {
    return { matched: true, alias: null }
  }
  const alias = model.aliases?.find(a => normalizeSearchText(a).includes(needle)) ?? null
  return { matched: alias !== null, alias }
}
